import React from 'react';
import './Select.css';

const Select = ({ options = [], value, onChange, placeholder, className = '', ...props }) => {
  return (
    <select
      value={value}
      onChange={onChange}
      className={`select ${className}`}
      {...props}
    >
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options.map((option) => (
        <option key={option.key || option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default Select; 